export default __webpack_public_path__ + "static/media/Terms_Conditions_of_Sale.3fa62137.pdf";